export const CLEAR_EVENTS = 'CLEAR_EVENTS';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE';
export const GET_EVENTS_REQUEST = 'GET_EVENTS_REQUEST';
export const SET_EVENTS_DATE = 'SET_EVENTS_DATE';

export const SELECT_EVENT = 'SELECT_EVENT';
export const CLEAR_SELECTED_EVENT = 'CLEAR_SELECTED_EVENT';
